module.exports = __webpack_public_path__ + "img/ic-navi-cancle.5a007da9.svg";